if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.pendingThumbnailTarget = null;
        this.mql = window.matchMedia('(min-width: 750px)');
        this.adoptConfira3dButton();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.slider?.addEventListener('pointerdown', () => this.clearPendingThumbnailTarget());
        this.elements.viewer.slider?.addEventListener('keydown', () => this.clearPendingThumbnailTarget());
        this.elements.viewer.addEventListener('slideChanged', (event) => {
          cancelAnimationFrame(this._slideRaf);
          this._slideRaf = requestAnimationFrame(() => this.onSlideChanged(event));
        });
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        if (!this.mql.matches && this.closest('.product--mobile-hover_gallery')) {
          window.addEventListener('DOMContentLoaded', () => {
            this.elements.viewer.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
          });
        }
      }

      onSlideChanged(event) {
        const currentMediaId = event.detail.currentElement?.dataset.mediaId;
        if (this.pendingThumbnailTarget) {
          if (currentMediaId !== this.pendingThumbnailTarget) return;
          this.clearPendingThumbnailTarget();
        }

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentMediaId}"]`
        );
        if (thumbnail?.querySelector('button[aria-current]')) return;
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        this.setPendingThumbnailTarget(mediaId);
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      setPendingThumbnailTarget(mediaId) {
        this.pendingThumbnailTarget = mediaId;
      }

      clearPendingThumbnailTarget() {
        this.pendingThumbnailTarget = null;
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        const isHorizontal = this.elements.thumbnails.dataset.thumbnailOrientation === 'horizontal';

        if (isHorizontal) {
          const slider = this.elements.thumbnails.slider;
          const nearRightEdge = thumbnail.offsetLeft + thumbnail.clientWidth > slider.clientWidth + slider.scrollLeft - 60;
          const nearLeftEdge = thumbnail.offsetLeft < slider.scrollLeft + 60;

          if (nearRightEdge) {
            slider.scrollTo({ left: thumbnail.offsetLeft - slider.clientWidth + thumbnail.clientWidth + 60, behavior: 'smooth' });
          } else if (nearLeftEdge) {
            slider.scrollTo({ left: thumbnail.offsetLeft - 60, behavior: 'smooth' });
          }
        } else {
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop - 1 });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      adoptConfira3dButton() {
        if (!this.closest('.product--hover_gallery') && !this.closest('.product--mobile-hover_gallery')) return;

        const firstSlide = this.elements.viewer?.querySelector('.product__media-item');
        const target = firstSlide?.querySelector('.product-media-container') || firstSlide;
        if (!target) return;

        const move = () => {
          const btn = document.querySelector('.confira3d-inline-btnhost');
          const overlay = document.querySelector('.confira3d-overlay-host');
          if (!btn || target.contains(btn)) return false;
          target.appendChild(btn);
          if (overlay) target.appendChild(overlay);
          return true;
        };

        if (move()) return;

        const observer = new MutationObserver(() => {
          if (move()) observer.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  );
}
